import {Component, OnInit} from '@angular/core'
import {UserService} from '../user/user.service'
import {LoaderService} from '../ui-shared/loader/loader.service'

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent implements OnInit {
  constructor(public user: UserService, public loader: LoaderService) {}

  ngOnInit() {
    this.loader.stop()
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/not-found/not-found.component.ts